const Input = ({
  label,
  name,
  placeholder,
  type,
  value,
  onChange,
  className,
  required,
  accept,
  disabled,
  options,
  textareaRows,
  min,
  style,
  lineHeight
}) => {
  return (
    <div>
      {label && (
        <label className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}
      {type == "textarea" ? (
        <textarea
          name={name}
          className={`form-control ${className ? className : ""}`}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e)}
          required={required}
          style={{ lineHeight: "normal", ...(style || {}) }}
          rows={textareaRows}
        />
      ) : type == "file" ? (
        <input
          className={`form-control ${className ? className : ""}`}
          type="file"
          accept={accept}
          onChange={(e) => onChange(e)}
          style={{ lineHeight: "normal", ...(style || {}) }}
        />
      ) : type == "select" ? (
        <select
          value={value}
          onChange={(e) => onChange(e)}
          className={`form-control ${className ? className : ""}`}
          disabled={disabled}
          style={{ lineHeight: "normal", ...(style || {}) }}
        >
          {options?.map((option, index) => (
            <option value={option?.value} key={index}>
              {option?.label}
            </option>
          ))}
        </select>
      ) : type == "password" ? (
        <div>
          <input
            name={name}
            className={`form-control ${className ? className : ""}`}
            type={type}
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e)}
            required={required}
            disabled={disabled}
            style={{ lineHeight: lineHeight ? lineHeight : "normal", ...(style || {})  }}
          />
        </div>
      ) : type == "number" ? (
        <input
          name={name}
          className={`form-control ${className ? className : ""}`}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e)}
          required={required}
          disabled={disabled}
          style={{ lineHeight: lineHeight ? lineHeight : "normal", ...(style || {})  }}
          min={min}
        />
      ) : (
        <input
          name={name}
          className={`form-control ${className ? className : ""}`}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e)}
          required={required}
          disabled={disabled}
          style={{ lineHeight : "normal", ...(style || {})  }}
        />
      )}
    </div>
  );
};

export default Input;
